import { ListActionTarget } from '../../../models/ListActionTarget';
import { AddToCartOrListAction, CHANGE_TARGET, SET_TARGET_SELECTION_LIST_ID } from './types';

export function changeTarget(target: ListActionTarget): AddToCartOrListAction {
    return {
        type: CHANGE_TARGET,
        target
    };
}

export function setTargetSelectionListId(selectionListId: string): AddToCartOrListAction {
    return {
        type: SET_TARGET_SELECTION_LIST_ID,
        selectionListId
    };
}
